import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService} from "src/app/services/data.service";
import { AuthService } from "../../../services/auth.service";
import { Storage } from "@ionic/storage";
import { ToastController } from "@ionic/angular";


@Component({
  selector: "app-home",
  templateUrl: "./home.page.html",
  styleUrls: ["./home.page.scss"],
})
export class HomePage implements OnInit {
  results;
  product;
  searchTerm = "";
  cardInf: any[];
  cart =[];
  items: any;
  title="";
 

  constructor(
    private authService: AuthService,
    private storage: Storage,
    private toastController: ToastController,
    private dataService: DataService,
    private router: Router
  ) {}

  ngOnInit() {

    // this.cart = this.dataService.getShoppingList();
    this.items = this.dataService.getProduct();
    this.getCategories();
  }
 
  logout() {
    this.authService.logout();
    this.router.navigateByUrl('');
  }

  searchChanged() {
    this.results = this.dataService.getProductSearchResult(this.searchTerm)
    
  }

  getCategories() {
    this.cardInf = this.dataService.getCategories();
  }
  
  addToCart(cart){
    this.results = this.dataService.addProduct(cart);
  }

  openCart() {
    this.router.navigate(['cart'])
  }

}
